import Region from "./Region";
import ServiceSetup from "./ServiceSetup";
import AdvancedFields from "./AdvancedFields";
import Typography from "@mui/material/Typography";
import classes from "../PricingDistribution.module.css";
import clsx from "clsx";

export const SelfHostedFields = ({
    isFreezedByActivatedHaas,
    isHaasDaemonInitiated,
    isHaasDaemonAIInitiated,
}) => {
    // isFreezedByActivatedHaas = true; //TODO: remove after debug

    return (
        <>
            <div
                className={clsx(
                    classes.regionNameIdContainer,
                    isFreezedByActivatedHaas && classes.freezed
                )}
            >
                <Typography className={classes.header}>default_group</Typography>
                <Typography className={classes.value}>Fixed price per call</Typography>
            </div>
            <Typography
                className={clsx(classes.description, isFreezedByActivatedHaas && classes.freezed)}
            >
                Groups provide a mechanism of having multiple instances of a service in a
                geographically distributed manner. All service metadata can be managed at a group
                level. At this point we only support a single group per service. Support for
                multiple groups per Service is coming soon
            </Typography>
            <Region
                isFreezedByActivatedHaas={isFreezedByActivatedHaas}
                isHaasDaemonInitiated={isHaasDaemonInitiated}
            />
            <ServiceSetup
                isFreezedByActivatedHaas={isFreezedByActivatedHaas}
                isHaasDaemonAIInitiated={isHaasDaemonAIInitiated}
            />
            <AdvancedFields isFreezedByActivatedHaas={isFreezedByActivatedHaas} />
        </>
    );
};
